export const appendQueryParams = (baseUrl: string): string => {
  const currentParams = new URLSearchParams(window.location.search);

  if (currentParams.size === 0) {
    return baseUrl;
  }

  const url = new URL(baseUrl);
  currentParams.forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  return url.toString();
};
